export const baseHeaderExcel = [
  { text: 'Mã GV', value: 'code' },
  { text: 'Tên GV', value: 'name' },
  { text: 'Trạng thái', value: 'status' },
]
